module.exports = __webpack_public_path__ + "img/4m.dd663bd7.gif";